import { emailLink } from './emailLink';

const esCR = {
  ...emailLink,
};

export default esCR;
